export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? "dev";
export const APP_STORAGE_SCHEMA_VERSION = 1;

const STORAGE_SCHEMA_KEY = "aleaedge.storage.schemaVersion";

const SAFE_APP_KEYS_TO_REMOVE_ON_MIGRATION = [
  "aleaedge.query-cache",
  "aleaedge.ui-state",
] as const;

export const runStorageMigration = () => {
  try {
    const raw = localStorage.getItem(STORAGE_SCHEMA_KEY);
    const currentSchemaVersion = raw ? Number.parseInt(raw, 10) : 0;

    if (Number.isNaN(currentSchemaVersion) || currentSchemaVersion < APP_STORAGE_SCHEMA_VERSION) {
      SAFE_APP_KEYS_TO_REMOVE_ON_MIGRATION.forEach((key) => localStorage.removeItem(key));
      localStorage.setItem(STORAGE_SCHEMA_KEY, String(APP_STORAGE_SCHEMA_VERSION));
    }
  } catch {
    // Ignore storage unavailability in private browsing modes.
  }
};
